import React from 'react'

export default function BidAsk() {
  return (
    <div>BidAsk</div>
  )
}
